import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import {
  Box,
} from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';


const TopBar = ({ withBack, title, children }) => {
  const navigate = useNavigate()
  return (
    <Box sx={{
      height:"40px",
      display:"flex",
      gap:"10px",
      width:"100%",
      alignItems:"center",
      marginBottom:"20px",
    }}>
      {withBack &&
        <Box
          onClick={() => {
            navigate(withBack)
          }}
          sx={{
            cursor:"pointer",
          }}
        >
          <KeyboardBackspaceIcon/>
        </Box>
      }
      <Box sx={{
        fontSize:"18px",
        fontWeight:"bold"
      }}>
        {title}
      </Box>
      <Box sx={{flex:1}} />
      {children &&
        <Box sx={{
          display:"flex",
          gap:"20px"
        }}>
          {children}
        </Box>
      }
    </Box>
  )
}

export default TopBar
